var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.9a2.4 2.4 0 0 1 2.4-2.4h7.2A2.4 2.4 0 0 1 13 3.9v7.2a2.4 2.4 0 0 1-2.4 2.4H3.4A2.4 2.4 0 0 1 1 11.1V3.9Z",
    stroke: "#303752",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 6.9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM8.516 7.873 3.4 13.5h7.28A2.32 2.32 0 0 0 13 11.18v-.08c0-.28-.105-.387-.294-.594L10.288 7.87a1.2 1.2 0 0 0-1.772.004v0Z",
    stroke: "#303752",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewImage);
export default __webpack_public_path__ + "static/media/new-image.3db762718d9a002d2cad0bd9e41e2ed1.svg";
export { ForwardRef as ReactComponent };